import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Home from '../Home'
import FashionHome from '../../storefronts/indumentaria-femenina/FashionHome'

function PublicHome() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionHome />
  }

  return <Home />
}

export default PublicHome
